import "../styles/Tickets.css"

function Tickets() {
	return (
		<div className="Tickets left p-4 overflow-auto ">
		
			<div className="mx-4 ticket border border-light rounded p-4 d-flex flex-nowrap" style={{width:  "840px", zoom: "70%"}}>
				<div style={{width:  "540px"}}>
					<h2>CONCIERTO KAROL G EN VENEZUELA 2024</h2>
					<h3>@KAROLGVZLA24</h3>
					<p className="font-event text-nowrap">
						16.10.2024 | 10:00PM<br />
						ACCESO: 09:00PM
					</p>
					<p className="font-event text-nowrap">
						PALCO H235
					</p>				
					<p className="font-event text-nowrap">
						139 Pail Wayne Haggerty Road<br />
						New Orleans, LA 70114
					</p>
				</div>
				<div className="d-flex text-end justify-content-end px-4" style={{width:  "100px"}}>
					<div className="d-block  font-event text-primary text-end justify-content-end text-nowrap">N 43214567</div>
					<div className="d-block align-self-end text-right justify-content-end">
						<img src={"logo192.png"} height="30em" alt="Logo" />
					</div>
				</div>
				<div className="ticket-line" style={{width:  "200px"}}>
					<div className="px-4">
						<h2 className="mb-4 text-nowrap">$18</h2>
						<p className="font-event mt-4 mb-4 text-nowrap">
							16.10.2024 | 10:00PM<br />
							ACCESO: 09:00PM
						</p>
						<p className="font-event text-nowrap">
							PALCO H235
						</p>
						<p className="font-event text-primary mt-4 text-nowrap">N 43214567</p>
					</div>
				</div>						
			</div>
			<br />
			<br />
			<br />
		</div>
	);
}

export default Tickets;
